export const GA_CLICK_ACTION = 'GA:click';
export const GA_VIEW_ACTION = 'GA:view';
export const GA_IMPRESSIONS_ACTION = 'GA:impressions';
export const GA_BUTTON_IMPRESSION = 'GA:buttonImpression';
export const GA_CLICKPRODUCT_ACTION = 'GA:clickProduct';
export const GA_EXCEPTION_ACTION = 'GA:exception';
export const GA_PAGEVIEW_ACTION = 'GA:pageview';
export const GA_CHECKOUT_ACTION = 'GA:checkout';
export const GA_PURCHASE_ACTION = 'GA:purchase';
export const GA_PROMOVIEW_ACTION = 'GA:promoView';
export const GA_PROMOCLICK_ACTION = 'GA:promoClick';
export const GA_CLICK_BUTTON_ACTION = 'GA:clickButton';
export const GA_UNFOCUS_ACTION = 'GA:unfocus';
export const GA_FOCUS_ACTION = 'GA:focus';
export const GA_ADDTOCARD_ACTION = 'GA:addToCart';
export const GA_REMOVEFROMCARD_ACTION = 'GA:removeFromCart';
export const GA_SHOW_ACTION = 'GA:show';
export const GA_ADD_TO_COMPARISON = 'GA:addToComparisonList';
export const GA_REMOVE_FROM_COMPARISON = 'GA:removeFromComparisonList';
export const GA_ADD_TO_SHOPLIST = 'GA:addToShoppingList';
export const GA_REMOVE_FROM_SHOPLIST = 'GA:removeFromShoppingList';
export const GA_ITEM_PROMO_VIEW = 'ga-promo-view';
export const GA_ITEM_PROMO_CLICK = 'ga-promo-click';
export const GA_CAROUSEL_PROMO_VIEW = 'ga-carousel-promo-view';
export const GA_CAROUSEL_PROMO_CLICK = 'ga-carousel-promo-click';
export const GA_BLOCK_IMPRESSION = 'GA:blockImpression';
export const GA_ABTEST = 'GA:AB_TEST';

class Analytics {
  constructor() {
    this.hasFlagLogAnalytics = localStorage.getItem('enabledLogAnalytics');
    if (!this.hasFlagLogAnalytics) {
      localStorage.setItem('enabledLogAnalytics', '');
    }
  }

  /**
   *
   * @param {{name: string|any[], position: string}} params
   */
  sendButtonImpression(params) {
    this._sendEvent(GA_BUTTON_IMPRESSION, params);
  }

  /**
   *
   * @param {{name: string|any[], position: string}} params
   */
  sendBlockImpression(params) {
    this._sendEvent(GA_BLOCK_IMPRESSION, params);
  }

  /**
   *
   * @param {{name: string|any[], position: string}} params
   */
  sendView(params) {
    this._sendEvent(GA_VIEW_ACTION, params);
  }

  /**
   *
   * @param {{name: string|any[], position: string}} params
   */
  sendClick(params) {
    this._sendEvent(GA_CLICK_ACTION, params);
  }

  /**
   *
   * @param {{
   * elementType: string,
   * elementBlock: string,
   * productName: string,
   * productId: string,
   * productPrice: string,
   * productPosition: string
   * }} params
   */
  sendImpressions(params) {
    this._sendEvent(GA_IMPRESSIONS_ACTION, params);
  }

  /**
   *
   * @param {{
   * elementType: string,
   * elementBlock: string,
   * elementName: string,
   * productName: string,
   * productId: string,
   * productPrice: string,
   * productPosition: string
   * }} params
   */
  sendClickProduct(params) {
    this._sendEvent(GA_CLICKPRODUCT_ACTION, params);
  }

  /**
   *
   * @param {{
   * elementType: string,
   * elementBlock: string,
   * productName: string,
   * productId: string,
   * productPrice: string,
   * productQuantity: string,
   * productPosition: string
   * }} params
   */
  sendAddToCard(params) {
    this._sendEvent(GA_ADDTOCARD_ACTION, params);
  }

  /**
   *
   * @param {{
   * elementType: string,
   * elementBlock: string,
   * productName: string,
   * productId: string,
   * productPrice: string,
   * productQuantity: string,
   * productPosition: string
   * }} params
   */
  sendRemoveFromCart(params) {
    this._sendEvent(GA_REMOVEFROMCARD_ACTION, params);
  }

  /**
   *
   * @param {{eventCategory: string, eventAction: string, eventLabel: string}} params
   */
  sendException(params) {
    this._sendEvent(GA_EXCEPTION_ACTION, params);
  }

  /**
   * @param params
   */
  sendPageView(params) {
    this._sendEvent(GA_PAGEVIEW_ACTION, params);
  }

  /**
   * @param {{
   * elementType: string,
   * elementBlock: string,
   * promotions: any[]}} params
   */
  sendPromoView(params) {
    this._sendEvent(GA_PROMOVIEW_ACTION, params);
  }

  /**
   * @param {{
   * elementBlock: string,
   * elementType: string,
   * promotions: {any}[]}} params
   */
  sendPromoClick(params) {
    this._sendEvent(GA_PROMOCLICK_ACTION, params);
  }

  /**
   * @param params
   */
  sendCheckout(params) {
    this._sendEvent(GA_CHECKOUT_ACTION, params);
  }

  /**
   * @param params
   */
  sendPurchase(params) {
    this._sendEvent(GA_PURCHASE_ACTION, params);
  }

  sendClickButton(params) {
    this._sendEvent(GA_CLICK_BUTTON_ACTION, params);
  }

  sendFocus(params) {
    this._sendEvent(GA_FOCUS_ACTION, params);
  }

  sendUnFocus(params) {
    this._sendEvent(GA_UNFOCUS_ACTION, params);
  }

  sendRemoveFromCard(params) {
    this._sendEvent(GA_REMOVEFROMCARD_ACTION, params);
  }

  sendShow(params) {
    this._sendEvent(GA_SHOW_ACTION, params);
  }

  sendAddToCompare(params) {
    this._sendEvent(GA_ADD_TO_COMPARISON, params);
  }

  sendRemoveFromCompare(params) {
    this._sendEvent(GA_REMOVE_FROM_COMPARISON, params);
  }

  sendAddToShopList(params) {
    this._sendEvent(GA_ADD_TO_SHOPLIST, params);
  }

  sendRemoveFromShopList(params) {
    this._sendEvent(GA_REMOVE_FROM_SHOPLIST, params);
  }

  sendGAABTest(params) {
    this._sendEvent(GA_ABTEST, params);
  }

  /**
   *
   * @param event
   * @param params
   * @private
   */
  _sendEvent(event, params) {
    if (this.hasFlagLogAnalytics) {
      console.info(event, params);
    }
    document.dispatchEvent(new CustomEvent(event, { detail: params }));
  }
}

export const analytics = new Analytics();
